//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import JSONEditor from 'jsoneditor';
import bfjs from 'js-beautify';
import codemirror from 'codemirror';
import 'codemirror/addon/lint/lint.css';
import 'codemirror/addon/lint/lint.js';
import { execExpressionDeep } from './expression';
import { isObject } from 'lodash';
import * as eslint from 'eslint-linter-browserify';
import { minify } from 'terser';
import { mapGetters } from 'vuex';

const throttle = function (fn, ms) {
  let timing = null;
  return function (...arg) {
    if (!timing) {
      timing = setTimeout(() => {
        fn.apply(this, arg);
        timing = null;
      }, ms);
    }
  };
};

const distance = function (a, b) {
  return Math.sqrt((a[0] - b[0]) ** 2 + (a[1] - b[1]) ** 2);
};

const parttenMached = function (raw) {
  if ((raw.includes('"{{') && raw.includes('}}"')) || (raw.includes('"{%') && raw.includes('%}"')))
    return true;
  return false;
};

const getExpression = function (raw) {
  let si = raw.indexOf('"{{');
  let ei = raw.indexOf('}}"');
  if (si === -1 || ei === -1) {
    si = raw.indexOf('"{%');
    ei = raw.indexOf('%}"');
    if (si === -1 || ei === -1) {
      return null;
    }
  }
  return raw.slice(si + 3, ei);
};

// ESLint 配置（针对表达式编辑器）- 使用 flat config 格式
const eslintConfig = [
  {
    languageOptions: {
      ecmaVersion: 2022,
      sourceType: 'module',
      globals: {
        // 浏览器全局变量
        window: 'readonly',
        document: 'readonly',
        console: 'readonly',
        // 表达式可能使用的变量
        data: 'readonly',
      },
    },
    rules: {
      // 关闭代码风格检查，但保留语法检查
      'no-undef': 'off', // 关闭未定义变量检查，因为表达式可能使用外部变量（如 data）
      'no-unused-vars': 'off', // 关闭未使用变量检查
      semi: 'off', // 开启分号检查
      'no-console': 'off', // 允许使用 console
      'no-invalid-this': 'off', // 允许使用 this（代码在函数上下文中）
      'no-return-await': 'off', // 允许 return await
      quotes: 'off', // 允许使用单引号和双引号
      // 注意：ESLint 会自动检测语法错误，不需要额外规则
    },
  },
];

// 创建 ESLint Linter 实例
let eslintLinter = null;
try {
  eslintLinter = new eslint.Linter();
} catch (error) {
  console.error('ESLint Linter 初始化失败:', error);
}

// 创建 CodeMirror lint 函数
const javascriptLinter = (text) => {
  const errors = [];
  if (!text || !text.trim()) {
    return errors;
  }

  if (!eslintLinter) {
    console.warn('ESLint Linter 未初始化');
    return errors;
  }

  try {
    // 使用 ESLint 检查代码
    // 将代码包装在函数中，以便允许 return 语句
    // 这样 ESLint 会认为代码在函数作用域中执行
    const wrappedCode = `function f() {\n${text}\n}`;

    // eslint-linter-browserify 使用 flat config 格式
    let eslintErrors = [];

    // 尝试使用 verify 方法，传入 flat config 格式的配置
    if (typeof eslintLinter.verify === 'function') {
      try {
        // 确保配置是数组格式（flat config）
        const config = Array.isArray(eslintConfig) ? eslintConfig : [eslintConfig];
        // 检查包装后的代码
        const wrappedErrors = eslintLinter.verify(wrappedCode, config);
        // 过滤并调整错误位置（因为代码被包装了，行号需要减1）
        eslintErrors = wrappedErrors
          .filter((error) => {
            // 过滤掉函数包装相关的错误
            // 只保留实际代码中的错误（行号大于1，因为第一行是 function() {）
            return error.line > 1;
          })
          .map((error) => {
            // 调整行号：减去包装的函数声明行（function() { 这一行）
            return {
              ...error,
              line: error.line - 1,
            };
          });
      } catch (verifyError) {
        console.warn('ESLint verify 失败:', verifyError);
        // 如果 verify 失败，抛出错误以便使用回退方案
        throw verifyError;
      }
    } else {
      console.warn('ESLint Linter verify 方法不可用');
      throw new Error('ESLint API 不可用');
    }

    // 将 ESLint 错误转换为 CodeMirror lint 格式
    eslintErrors.forEach((eslintError) => {
      // ESLint 的行号是从1开始的，需要减1转换为 CodeMirror 的行号（从0开始）
      const line = Math.max(0, eslintError.line - 1);
      const column = Math.max(0, (eslintError.column || 1) - 1);

      // 计算结束位置
      const lines = text.split('\n');
      const lineText = lines[line] || '';
      let endColumn = column + 1;

      // 如果 ESLint 提供了结束位置，使用它
      if (eslintError.endColumn) {
        endColumn = Math.max(0, eslintError.endColumn - 1);
      } else if (eslintError.endLine && eslintError.endLine === eslintError.line) {
        // 如果结束行相同，使用结束列
        endColumn = Math.max(0, (eslintError.endColumn || column + 1) - 1);
      }

      errors.push({
        message: eslintError.message || '语法错误',
        severity: eslintError.severity === 2 ? 'error' : 'warning',
        from: codemirror.Pos(line, column),
        to: codemirror.Pos(line, Math.min(endColumn, lineText.length)),
      });
    });
  } catch (error) {
    // 如果 ESLint 检查失败，记录错误但不阻止编辑器使用
    console.error('ESLint 检查失败:', error);
    // 如果 ESLint 检查失败，尝试使用基本的语法检查作为回退
    try {
      /* eslint-disable no-eval, no-new-func */
      new Function(text);
      /* eslint-enable no-eval, no-new-func */
    } catch (syntaxError) {
      // 基本的语法错误检测
      const lines = text.split('\n');
      const stackMatch = syntaxError.stack?.match(/<anonymous>:(\d+):(\d+)/);
      if (stackMatch) {
        const line = Math.max(0, parseInt(stackMatch[1], 10) - 1);
        const column = Math.max(0, parseInt(stackMatch[2], 10) - 1);
        const lineText = lines[line] || '';
        errors.push({
          message: syntaxError.message.replace(/^.*?: /, '') || '语法错误',
          severity: 'error',
          from: codemirror.Pos(line, column),
          to: codemirror.Pos(line, Math.min(column + 1, lineText.length)),
        });
      }
    }
  }

  return errors;
};

export default {
  name: 'EditorContainer',
  props: {
    json: {
      type: String,
      default: '{}',
    },
    mode: {
      type: String,
      default: 'code',
    },
    jsonData: {
      type: String,
      default: '{}',
    },
    rootDomSelector: {
      type: String,
      default: '#jsonEditComponent',
    },
    iframeSrc: {
      type: String,
      default: '/json-edit',
    },
  },
  data() {
    return {
      editor: null, // 编辑器对象
      useMonacoEditor: false, // 带json schema的编辑器
      showExpressionEditor: false, // 是否显示表达式编辑器
      editingRowNumber: null, // 正在编辑的行号
      expressionEditor: null, // 表达式编辑器实例
      splitPosition: 50, // 分割位置百分比，默认左右平分50%
      isResizing: false, // 是否正在调整大小
      currentEditingData: null, // 当前编辑的数据（用于保存）
      editorId: `jsoneditor-${Date.now()}`, // 唯一的编辑器ID
      expressionEditorTextareaId: `expressionEditorTextarea-${Date.now()}`, // 唯一的textarea ID
      showDebugPanel: false, // 是否显示调试面板
      debugSplitPosition: 40, // 调试区域分割位置百分比，默认表达式编辑器40%
      isResizingDebug: false, // 是否正在调整调试区域大小
      debugInputJson: '{}', // 调试输入的JSON数据
      debugResult: null, // 调试执行结果
      debugInputEditor: null, // 调试输入编辑器实例
      debugInputTextareaId: `debugInputTextarea-${Date.now()}`, // 唯一的调试输入textarea ID
      debugInputSplitPosition: 40, // 调试输入区域分割位置百分比，默认上方40%
      isResizingDebugInput: false, // 是否正在调整调试输入区域大小
      debugResultKey: 0, // 用于触发过渡动画的key
      showAiDialog: false, // 是否显示AI生成弹窗
      aiInputText: '', // AI输入的需求文本
      isGenerating: false, // 是否正在生成中
      selectedExpressionType: 'template', // 当前选中的表达式类型：'template' 或 'block'
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    wrapperStyle() {
      return {
        display: 'flex',
        position: 'relative',
        height: '100%',
      };
    },
    mainAreaStyle() {
      if (this.showExpressionEditor) {
        return {
          width: `calc(${this.splitPosition}% - 2px)`,
          marginRight: '4px',
          transition: 'width 0.1s ease',
        };
      }
      return {
        flex: 1,
      };
    },
    editorAreaStyle() {
      if (this.showExpressionEditor) {
        return {
          width: `calc(${100 - this.splitPosition}% - 2px)`,
          minWidth: '650px',
          marginLeft: '4px',
          transition: 'width 0.1s ease',
        };
      }
      return {};
    },
    expressionEditorContentStyle() {
      if (this.showDebugPanel) {
        return {
          height: `calc(${this.debugSplitPosition}% - 2px)`,
          transition: 'height 0.1s ease',
        };
      }
      return {
        flex: 1,
      };
    },
    debugPanelStyle() {
      if (this.showDebugPanel) {
        return {
          height: `calc(${100 - this.debugSplitPosition}% - 2px)`,
          transition: 'height 0.1s ease',
        };
      }
      return {};
    },
    debugInputAreaStyle() {
      return {
        height: `calc(${this.debugInputSplitPosition}% - 2px)`,
        transition: 'height 0.1s ease',
      };
    },
    debugResultAreaStyle() {
      return {
        height: `calc(${100 - this.debugInputSplitPosition}% - 2px)`,
        transition: 'height 0.1s ease',
      };
    },
    jurisdiction() {
      return {
        aiGenExpression: this.getElementList.includes('ai-gen-expression'),
      };
    },
  },
  watch: {
    jsonData: {
      handler(newVal) {
        if (this.editor && !this.useMonacoEditor) {
          try {
            const data = newVal ? JSON.parse(newVal) : {};
            this.editor.set(data);
          } catch (err) {
            console.error(err);
          }
        }
      },
      immediate: false,
    },
    json: {
      handler(newVal) {
        if (this.editor && !this.useMonacoEditor) {
          try {
            const data = newVal ? JSON.parse(newVal) : {};
            this.editor.set(data);
          } catch (err) {
            console.error(err);
          }
        }
      },
      immediate: false,
    },
  },
  mounted() {
    this.initEditor();
    this.initEditorClickHandler();
    window.addEventListener('message', this.handleIframeChange);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleIframeChange);
    // 清理表达式编辑器
    if (this.expressionEditor) {
      this.expressionEditor.toTextArea();
      this.expressionEditor = null;
    }
    // 清理调试输入编辑器
    if (this.debugInputEditor) {
      this.debugInputEditor.toTextArea();
      this.debugInputEditor = null;
    }
    // 清理JSONEditor
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
  },
  methods: {
    isObject,
    // 初始化编辑器
    initEditor() {
      this.$nextTick(() => {
        setTimeout(() => {
          const dom = document.getElementById(this.editorId);
          if (!dom) return;
          dom.innerHTML = ''; // 防止重复触发
          this.editor = new JSONEditor(dom, {
            language: 'zh-CN',
            mode: this.mode,
            modes: ['code', 'tree', 'view', 'text'],
            search: true,
          });

          // set json
          let data = this.jsonData || this.json || '{}';
          try {
            data = data ? JSON.parse(data) : {};
          } catch (err) {
            console.log(err);
          }
          this.editor.set(data);
          if (this.mode === 'tree') {
            // 展开所有节点(tree模式)
            this.editor.expandAll();
          }

          // 通知父组件编辑器已准备好
          this.$emit('editor-ready', this.editor);
        }, 100);
      });
    },
    // 初始化编辑器点击事件处理
    initEditorClickHandler() {
      this.$nextTick(() => {
        setTimeout(() => {
          const editorDom = document.querySelector('.ace_content');
          const rootDom = document.querySelector(this.rootDomSelector);
          if (!editorDom || !rootDom) return;

          editorDom.addEventListener('click', () => {
            // 如果右侧表达式编辑器已经打开，不显示左侧的编辑按钮
            if (this.showExpressionEditor) return;

            const raw = this.getLine(editorDom, 'peek');
            if (!parttenMached(raw)) return;

            const clickX = event.clientX;
            const clickY = event.clientY;
            const MOVE_SENSITIVITY = 20;
            let counter = MOVE_SENSITIVITY;
            // show button
            const editButton = document.createElement('button');
            editButton.textContent = '编辑表达式';
            editButton.style.position = 'fixed';
            editButton.style.left = `${clickX}px`;
            editButton.style.top = `${clickY - 35}px`;
            editButton.style.padding = '4px 8px';
            editButton.style.fontSize = '12px';
            editButton.style.backgroundColor = '#295FDF';
            editButton.style.color = 'white';
            editButton.style.border = 'none';
            editButton.style.borderRadius = '4px';
            editButton.style.cursor = 'pointer';
            editButton.style.opacity = 0.5;
            editButton.style['z-index'] = 200000;
            editButton.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
            editButton.style.transition = 'opacity 0.2s ease';
            rootDom.appendChild(editButton);
            const distanceHandler = throttle((e) => {
              const a = [e.clientX, e.clientY];
              const b = [clickX, clickY];
              const calculateDistance = distance(a, b);
              if (calculateDistance > 30) {
                decompose();
              }
            }, 100);
            const observer = new MutationObserver((mutationsList) => {
              for (const mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                  counter--;
                  if (counter < 0) {
                    decompose();
                  }
                }
              }
            });
            const decompose = () => {
              if (rootDom.contains(editButton)) {
                rootDom.removeChild(editButton);
              }
              editorDom.removeEventListener('mousemove', distanceHandler);
              editorDom.removeEventListener('click', decompose);
              observer.disconnect();
              counter = MOVE_SENSITIVITY;
            };
            editButton.onclick = (e) => {
              e.stopPropagation();
              this.getLine(editorDom);
              decompose();
            };
            editButton.addEventListener('mouseover', () => {
              editButton.style.opacity = '1';
            });
            editButton.addEventListener('mouseout', () => {
              editButton.style.opacity = '0.5';
            });
            editorDom.addEventListener('mousemove', distanceHandler);
            editorDom.addEventListener('click', decompose);
            observer.observe(editorDom, { attributes: true });
            setTimeout(decompose, 10000);
          });
        }, 500);
      });
    },
    getLine(ref, mod) {
      const srow = this.editor.getTextSelection()?.start?.row;
      const erow = this.editor.getTextSelection()?.end?.row;
      if (srow === erow) {
        // get from editor
        const jsonObj = JSON.parse(this.editor.getText()) ?? {};
        const jsonObjList = JSON.stringify(jsonObj, null, 2)?.split('\n') || [];
        const line = jsonObjList[srow - 1];
        if (mod === 'peek') return line;
        const content = getExpression(line);
        if (!content) return srow;

        // 将转义的双引号还原为普通双引号
        const unescapedContent = content.replaceAll('\\"', '"');

        const bfjsOption = {
          max_preserve_newlines: '1',
          break_chained_methods: true,
          wrap_line_length: '70',
        };
        const formattedContent = bfjs.js(unescapedContent.trim(), bfjsOption);

        // 显示表达式编辑器（srow 是从1开始的行号）
        this.editingRowNumber = srow;
        this.showExpressionEditor = true;

        // 通知父组件表达式编辑器已打开
        this.$emit('expression-editor-open');

        // 判断表达式类型：{{ }} 或 {% %}
        const isTemplateExpression = line.indexOf('"{{') !== -1;
        const expressionType = isTemplateExpression ? 'template' : 'block';

        // 设置选中的表达式类型
        this.selectedExpressionType = expressionType;

        // 保存当前编辑的数据
        this.currentEditingData = {
          srow,
          line,
          content,
          jsonObjList,
          expressionType, // 保存表达式类型
          expressionStartIndex: isTemplateExpression
            ? line.indexOf('"{{') + 3
            : line.indexOf('"{%') !== -1
            ? line.indexOf('"{%') + 3
            : 0,
        };

        // 设置左侧编辑器为只读
        this.setEditorReadOnly(true);

        // 等待DOM更新后初始化编辑器
        this.$nextTick(() => {
          this.initExpressionEditor(formattedContent, srow, line, content, jsonObjList);
        });

        return srow;
      }
    },
    // 初始化表达式编辑器
    initExpressionEditor(formattedContent) {
      // 如果已有编辑器实例，先销毁
      if (this.expressionEditor) {
        this.expressionEditor.toTextArea();
        this.expressionEditor = null;
      }

      const textarea = document.getElementById(this.expressionEditorTextareaId);
      if (!textarea) return;

      textarea.value = formattedContent;

      const bfjsOption = {
        max_preserve_newlines: '1',
        break_chained_methods: true,
        wrap_line_length: '70',
      };

      this.expressionEditor = codemirror.fromTextArea(textarea, {
        lineNumbers: true,
        mode: 'javascript',
        theme: 'default',
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-lint-markers'],
        lint: javascriptLinter,
      });

      this.expressionEditor.focus();

      // 手动触发一次 lint 检查
      this.$nextTick(() => {
        if (this.expressionEditor && this.expressionEditor.performLint) {
          this.expressionEditor.performLint();
        }
      });

      const self = this; // 保存 this 引用，以便在 keyMap 中使用
      codemirror.keyMap.custom = {
        'Cmd-L'(cm) {
          const value = cm.getValue();
          const linted = bfjs.js(value.trim(), bfjsOption);
          cm.setValue(linted);
        },
        'Cmd-S'(cm, event) {
          // 阻止浏览器默认的保存行为
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }
          // 直接调用 saveExpression 方法
          self.saveExpression();
          // 返回 false 进一步阻止默认行为
          return false;
        },
      };
      this.expressionEditor.addKeyMap('custom');
    },
    // 保存表达式
    async saveExpression() {
      if (!this.expressionEditor || !this.currentEditingData) {
        return;
      }

      const { srow, line, content, jsonObjList } = this.currentEditingData;
      const value = this.expressionEditor.getValue();
      const errors = javascriptLinter(value);
      if (javascriptLinter(value)?.length > 0) {
        console.error(errors);
        this.$message.error('表达式存在错误，请修复后再保存');
        return;
      }
      let compressed = value;
      try {
        // 将单行注释 // 转为块注释 /* */，防止：
        // 1. 尾部 // 注释吞掉包装函数的闭合括号导致 terser 解析失败
        // 2. 去除换行后 // 注释吞掉后续代码
        const preprocessed = value.replace(/\/\/([^\n]*)/g, '/*$1*/');
        // 使用 terser.minify 只做压缩和补充分号，不做其他转换
        const result = await minify(`function f(){${preprocessed}}`, {
          mangle: false, // 不混淆变量名
          compress: false, // 关闭所有代码优化，只保留空白压缩
          output: {
            beautify: false, // 不美化，压缩空白（默认值，会移除不必要的空白字符）
            semicolons: true, // 确保有分号
            quote_style: 3, // 保持原始引号样式，不改变单双引号
            keep_numbers: true, // 保持数字原样，不转换为科学计数法（如 1000 不会变成 1e3）
            comments: true, // 保留注释
          },
        });
        if (result.code) {
          // 移除包装的函数声明，提取压缩后的代码
          compressed = result.code.replace(/^function\s+f\(\)\{/, '').replace(/\}$/, '');
          // 替换换行符为空格，防止嵌入 JSON 字符串后解析失败
          compressed = compressed.replace(/\n/g, ' ');
        }
      } catch (error) {
        console.error(error);
        this.$message.error('表达式存在错误，请修复后再保存');
        return;
      }

      compressed = compressed.replaceAll('"', '\\"');
      console.log('压缩后的表达式：', compressed);

      // 根据选中的表达式类型决定如何包裹表达式
      let wrappedExpression = '';

      if (this.selectedExpressionType === 'template') {
        // 使用 {{ }} 包裹
        wrappedExpression = `"{{${compressed}}}"`;
      } else if (this.selectedExpressionType === 'block') {
        // 使用 {%%} 包裹
        wrappedExpression = `"{%${compressed}%}"`;
      } else {
        // 默认使用原来的方式（保持兼容性）
        wrappedExpression = compressed;
      }

      // 找到原始行中的表达式部分（包括包裹符号）并替换
      // 使用非贪婪匹配，匹配整个表达式部分
      const templateMatch = line.match(/"\{\{[^}]*\}\}"/);
      const blockMatch = line.match(/"\{%[^%]*%\}"/);

      let newLine = line;
      if (templateMatch || blockMatch) {
        // 如果找到了表达式部分，根据 expressionType 替换
        if (templateMatch) {
          newLine = line.replace(templateMatch[0], wrappedExpression);
        } else if (blockMatch) {
          newLine = line.replace(blockMatch[0], wrappedExpression);
        }
      } else {
        // 如果找不到匹配，使用原来的方式（保持兼容性）
        newLine = line.replace(content, compressed);
      }

      jsonObjList[srow - 1] = newLine;
      this.editor?.set(JSON.parse(jsonObjList.join('')));

      // 通知父组件数据已更新
      const updatedJson = jsonObjList.join('');
      this.$emit('update:jsonData', updatedJson);
      this.$emit('json-change', updatedJson);

      // 保存成功后关闭编辑器
      this.closeExpressionEditor();

      // 定位到被修改的行并将光标置于表达式开头
      this.$nextTick(() => {
        // 从编辑器获取更新后的行内容，计算表达式位置
        try {
          const aceEditor = this.editor.aceEditor || this.editor.ace;
          if (aceEditor) {
            const session = aceEditor.getSession();
            const updatedLine = session.getLine(srow - 1);
            if (updatedLine) {
              const expressionStartIndex =
                updatedLine.indexOf('"{{') !== -1
                  ? updatedLine.indexOf('"{{') + 3
                  : updatedLine.indexOf('"{%') !== -1
                  ? updatedLine.indexOf('"{%') + 3
                  : 0;
              this.navigateToExpressionLine(srow - 1, expressionStartIndex);
            }
          }
        } catch (error) {
          console.error('定位失败:', error);
        }
      });
    },
    // 格式化代码
    beautifyCode() {
      if (!this.expressionEditor) {
        return;
      }
      const bfjsOption = {
        max_preserve_newlines: '1',
        break_chained_methods: true,
        wrap_line_length: '70',
      };
      const value = this.expressionEditor.getValue();
      const linted = bfjs.js(value.trim(), bfjsOption);
      this.expressionEditor.setValue(linted);
    },
    // 格式化调试输入数据（JSON格式）
    beautifyDebugInput() {
      if (!this.debugInputEditor) {
        return;
      }
      try {
        const value = this.debugInputEditor.getValue();
        if (!value || !value.trim()) {
          this.debugInputEditor.setValue('{}');
          return;
        }
        // 解析JSON并格式化
        const parsed = JSON.parse(value.trim());
        const formatted = JSON.stringify(parsed, null, 2);
        this.debugInputEditor.setValue(formatted);
      } catch (error) {
        this.$message.error(`JSON格式化失败: ${error.message}`);
      }
    },
    // 关闭表达式编辑器
    closeExpressionEditor() {
      if (this.expressionEditor) {
        this.expressionEditor.toTextArea();
        this.expressionEditor = null;
      }
      if (this.debugInputEditor) {
        this.debugInputEditor.toTextArea();
        this.debugInputEditor = null;
      }
      this.showExpressionEditor = false;
      this.editingRowNumber = null;
      this.currentEditingData = null;
      this.showDebugPanel = false;
      this.debugResult = null;
      this.debugInputJson = '{}';

      // 恢复左侧编辑器为可编辑
      this.setEditorReadOnly(false);

      // 通知父组件表达式编辑器已关闭
      this.$emit('expression-editor-close');
    },
    // 设置编辑器只读状态
    setEditorReadOnly(readOnly) {
      if (!this.editor) return;

      // 如果是 code 模式，设置 Ace Editor 为只读
      if (this.mode === 'code') {
        const aceEditor = this.editor.aceEditor || this.editor.ace;
        if (aceEditor) {
          aceEditor.setReadOnly(readOnly);
        }
      } else {
        // 其他模式使用 JSONEditor 的 API
        if (this.editor.setOptions) {
          this.editor.setOptions({ readOnly });
        }
      }
    },
    // 定位到表达式所在行并将光标置于表达式开头
    navigateToExpressionLine(row, column) {
      if (!this.editor || this.mode !== 'code') return;

      try {
        const aceEditor = this.editor.aceEditor || this.editor.ace;
        if (!aceEditor) return;

        // 定位到指定行和列
        aceEditor.moveCursorTo(row, column);
        // 滚动到该行，使其可见
        aceEditor.scrollToLine(row, true, true, () => {});
        // 聚焦编辑器
        aceEditor.focus();
      } catch (error) {
        console.error('定位到表达式行失败:', error);
      }
    },
    // 开始调整大小
    startResize(e) {
      this.isResizing = true;
      const wrapper = e.currentTarget.parentElement;
      const startX = e.clientX;
      const startWidth = wrapper.offsetWidth;
      const startLeftPercent = this.splitPosition;

      // 使用节流优化性能
      const throttledAdjustHeight = throttle(() => {
        this.$nextTick(() => {
          this.adjustEditorHeight();
        });
      }, 100);

      const doResize = (moveEvent) => {
        const diffX = moveEvent.clientX - startX;
        const diffPercent = (diffX / startWidth) * 100;
        let newPercent = startLeftPercent + diffPercent;

        // 限制在20%到80%之间
        newPercent = Math.max(20, Math.min(80, newPercent));

        // 确保右侧表达式编辑器最小宽度为650px
        const rightWidth = ((100 - newPercent) / 100) * startWidth;
        if (rightWidth < 650) {
          // 如果右侧宽度小于650px，限制左侧最大百分比
          const maxLeftPercent = ((startWidth - 650) / startWidth) * 100;
          newPercent = Math.min(newPercent, maxLeftPercent);
        }

        this.splitPosition = newPercent;

        // 节流调整编辑器高度
        throttledAdjustHeight();
      };

      const stopResize = () => {
        this.isResizing = false;
        document.removeEventListener('mousemove', doResize);
        document.removeEventListener('mouseup', stopResize);
        // 停止拖动后调整编辑器高度
        this.$nextTick(() => {
          this.adjustEditorHeight();
        });
      };

      document.addEventListener('mousemove', doResize);
      document.addEventListener('mouseup', stopResize);
      e.preventDefault();
    },
    // 调整编辑器高度
    adjustEditorHeight() {
      // 调整 CodeMirror 编辑器高度
      if (this.expressionEditor) {
        this.expressionEditor.refresh();
      }
      // 调整调试输入编辑器高度
      if (this.debugInputEditor) {
        this.debugInputEditor.refresh();
      }

      // 调整 JSONEditor 高度（如果使用原编辑器）
      if (this.editor && this.editor.aceEditor) {
        const { aceEditor } = this.editor;
        if (aceEditor && aceEditor.resize) {
          aceEditor.resize();
        }
      }
    },
    handleIframeChange(event) {
      if (event.origin !== window.location.origin) {
        // 确保消息来自可信任的源
        return;
      }
      if (event?.data?.origin !== 'EDITOR') {
        return;
      }
      if (event.data?.type === 'READY') {
        this.$refs.iframe.contentWindow.postMessage(
          {
            value: this.jsonData || this.json,
            origin: 'EDITOR',
          },
          '*',
        );
      } else if (event.data?.type === 'CHANGE') {
        this.$emit('update:jsonData', event.data?.value ?? '{}');
        this.$emit('json-change', event.data?.value ?? '{}');
      }
    },
    handleChangeSwitch() {
      try {
        const data = this.jsonData || this.json ? JSON.parse(this.jsonData || this.json) : {};
        if (!this.useMonacoEditor) {
          this.editor.set(data);
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 获取编辑器实例
    getEditor() {
      return this.editor;
    },
    // 获取表达式编辑器是否打开
    isExpressionEditorOpen() {
      return this.showExpressionEditor;
    },
    // AI生成表达式
    async generateExpression() {
      if (!this.aiInputText || !this.aiInputText.trim()) {
        this.$message.warning('请输入您的需求');
        return;
      }

      if (!this.expressionEditor) {
        this.$message.error('表达式编辑器未初始化');
        return;
      }

      this.isGenerating = true;
      try {
        const response = await this.$request({
          url: this.$api.aiAgentRun,
          data: {
            id: 'layout-expression-generator',
            inputs: {
              my_query: `帮我生成一个表达式，${this.aiInputText.trim()}`,
            },
          },
        });

        // 读取 outputs.result
        const result = response?.outputs?.result || response?.result || '';

        if (!result) {
          this.$message.error('未获取到生成结果');
          return;
        }

        // 使用正则提取 {{ }} 或 {%%} 包裹的内容
        // 匹配 {{ }} 或 {%%} 包裹的内容（使用非贪婪匹配）
        const templateRegex = /\{\{(.*?)\}\}/;
        const blockRegex = /\{%(.*?)%\}/;

        let extractedExpression = '';
        let extractedExpressionType = null; // 记录提取的表达式类型
        let match;

        // 先尝试匹配 {{ }}
        match = result.match(templateRegex);
        if (match && match.length > 1) {
          // 提取第一个匹配组的内容（去掉 {{ 和 }}）
          extractedExpression = match[1].trim();
          extractedExpressionType = 'template'; // 标记为 template 类型
        } else {
          // 如果没有 {{ }}，尝试匹配 {%%}
          match = result.match(blockRegex);
          if (match && match.length > 1) {
            // 提取第一个匹配组的内容（去掉 {% 和 %}）
            extractedExpression = match[1].trim();
            extractedExpressionType = 'block'; // 标记为 block 类型
          }
        }

        if (!extractedExpression) {
          this.$message.warning(`未能从返回结果中提取到表达式，原始结果：${result}`);
          console.log('原始返回结果：', result);
          return;
        }

        // 如果 currentEditingData 存在，更新表达式类型为AI生成的类型
        if (this.currentEditingData && extractedExpressionType) {
          this.currentEditingData.expressionType = extractedExpressionType;
        }

        // 根据AI生成的类型切换 radio
        if (extractedExpressionType) {
          this.selectedExpressionType = extractedExpressionType;
        }

        // 将提取的表达式设置到编辑器中
        this.expressionEditor.setValue(extractedExpression);

        // 自动格式化代码
        this.$nextTick(() => {
          this.beautifyCode();
        });

        this.$message.success('表达式已生成并填充到编辑器');

        // 关闭弹窗
        this.showAiDialog = false;
        this.aiInputText = '';
      } catch (error) {
        console.error('生成表达式失败：', error);
        this.$message.error(`'生成表达式失败：${error.message || '未知错误'}'`);
      } finally {
        this.isGenerating = false;
      }
    },
    // 切换调试面板
    toggleDebugPanel() {
      this.showDebugPanel = !this.showDebugPanel;
      if (this.showDebugPanel) {
        // 设置高度分配：表达式编辑器40%，调试输入数据40%，执行结果20%
        this.debugSplitPosition = 40; // 表达式编辑器占40%
        // 调试输入数据占40%，执行结果占20%，总共占60%的调试面板
        // 所以调试输入数据在调试面板中的占比 = 40% / 60% = 66.67%
        this.debugInputSplitPosition = 66.67;
        this.$nextTick(() => {
          this.initDebugInputEditor();
          this.adjustEditorHeight();
        });
      } else {
        // 关闭调试面板时清理编辑器
        if (this.debugInputEditor) {
          this.debugInputEditor.toTextArea();
          this.debugInputEditor = null;
        }
      }
    },
    // 初始化调试输入编辑器
    initDebugInputEditor() {
      // 如果已有编辑器实例，先销毁
      if (this.debugInputEditor) {
        this.debugInputEditor.toTextArea();
        this.debugInputEditor = null;
      }

      const textarea = document.getElementById(this.debugInputTextareaId);
      if (!textarea) return;

      textarea.value = this.debugInputJson || '{}';

      this.debugInputEditor = codemirror.fromTextArea(textarea, {
        lineNumbers: true,
        mode: 'application/json',
        theme: 'default',
      });

      this.debugInputEditor.focus();
    },
    // 开始调整调试区域大小
    startDebugResize(e) {
      this.isResizingDebug = true;
      const wrapper = e.currentTarget.parentElement;
      const startY = e.clientY;
      const startHeight = wrapper.offsetHeight;
      const startTopPercent = this.debugSplitPosition;

      const doResize = (moveEvent) => {
        const diffY = moveEvent.clientY - startY;
        const diffPercent = (diffY / startHeight) * 100;
        let newPercent = startTopPercent + diffPercent;

        // 限制在30%到80%之间
        newPercent = Math.max(30, Math.min(80, newPercent));
        this.debugSplitPosition = newPercent;

        // 调整编辑器高度
        this.$nextTick(() => {
          this.adjustEditorHeight();
        });
      };

      const stopResize = () => {
        this.isResizingDebug = false;
        document.removeEventListener('mousemove', doResize);
        document.removeEventListener('mouseup', stopResize);
        // 停止拖动后调整编辑器高度
        this.$nextTick(() => {
          this.adjustEditorHeight();
        });
      };

      document.addEventListener('mousemove', doResize);
      document.addEventListener('mouseup', stopResize);
      e.preventDefault();
    },
    // 开始调整调试输入区域大小
    startDebugInputResize(e) {
      this.isResizingDebugInput = true;
      const wrapper = e.currentTarget.parentElement;
      const startY = e.clientY;
      const startHeight = wrapper.offsetHeight;
      const startTopPercent = this.debugInputSplitPosition;

      const doResize = (moveEvent) => {
        const diffY = moveEvent.clientY - startY;
        const diffPercent = (diffY / startHeight) * 100;
        let newPercent = startTopPercent + diffPercent;

        // 限制在20%到80%之间
        newPercent = Math.max(20, Math.min(80, newPercent));
        this.debugInputSplitPosition = newPercent;

        // 调整编辑器高度
        this.$nextTick(() => {
          this.adjustEditorHeight();
        });
      };

      const stopResize = () => {
        this.isResizingDebugInput = false;
        document.removeEventListener('mousemove', doResize);
        document.removeEventListener('mouseup', stopResize);
        // 停止拖动后调整编辑器高度
        this.$nextTick(() => {
          this.adjustEditorHeight();
        });
      };

      document.addEventListener('mousemove', doResize);
      document.addEventListener('mouseup', stopResize);
      e.preventDefault();
    },
    // 运行调试
    runDebug() {
      if (!this.expressionEditor) {
        this.$message.warning('请先输入表达式');
        return;
      }

      const expression = this.expressionEditor.getValue();
      if (!expression || !expression.trim()) {
        this.$message.warning('表达式不能为空');
        return;
      }

      // 先清空结果，触发消失动画
      this.debugResult = null;
      this.debugResultKey = 0;

      let inputData = {};
      try {
        const inputJson = this.debugInputEditor
          ? this.debugInputEditor.getValue()
          : this.debugInputJson || '{}';
        inputData = JSON.parse(inputJson);
      } catch (error) {
        // 使用 $nextTick 确保动画效果
        this.$nextTick(() => {
          this.debugResultKey++;
          this.debugResult = {
            error: `调试输入数据JSON解析错误: ${error.message}`,
          };
        });
        return;
      }

      try {
        // 根据选中的表达式类型添加对应的包装符号
        let expressionStr;
        if (this.selectedExpressionType === 'template') {
          // {{ }} 类型
          expressionStr = `{{ ${expression} }}`;
        } else {
          // {% %} 类型
          expressionStr = `{% ${expression} %}`;
        }
        const result = execExpressionDeep(expressionStr, inputData);
        // 使用 $nextTick 确保动画效果
        this.$nextTick(() => {
          this.debugResultKey++;
          this.debugResult = {
            result,
          };
        });
      } catch (error) {
        // 使用 $nextTick 确保动画效果
        this.$nextTick(() => {
          this.debugResultKey++;
          this.debugResult = {
            error: `执行错误: ${error.message}`,
          };
        });
      }
    },
  },
};
